@let configuration = configurationSg();

<div class="atn-space-report-rooms-by-occupant">
  <atn-ds-widget title="Configuration">
    <div class="atn-space-report-rooms-by-occupant__configuration">
      <atn-ds-select-single
        label="Format"
        [items]="formatItems"
        [value]="configuration.format"
        [required]="true"
        (valueChange)="formatChangeHandler($event)"
      />
    </div>
  </atn-ds-widget>

  <atn-ds-widget title="Filters">
    <div class="atn-space-report-rooms-by-occupant__filters">
      <atn-ds-section name="Occupants">
        <div class="atn-space-report-rooms-by-occupant__filter-section">
          <atn-space-dimension-filter [plugin]="employeeFilterPlugin" />
        </div>
      </atn-ds-section>
    </div>
  </atn-ds-widget>
</div>
